import React, { Fragment } from "react";

import "../block-chain-view/blockchainproduct.scss";
import { ProductChainDetails } from "./services/types";
import StrainChip from "../../components/strainTypeChip";

interface ProductInfoProps {
  productChainDetails: ProductChainDetails | null;
}

const ProductInfo = ({ productChainDetails }: ProductInfoProps) => {
  return (
    <div className="productInfo">
      <div className="product-title">
        {/* Small subtitle text above */}

        <div className="productTypeBadge">
          <p className="subtitle">Strain Name [CoA ID]</p>
          {productChainDetails?.strainType ? (
            <StrainChip type={productChainDetails?.strainType} />
          ) : (
            <Fragment />
          )}
        </div>

        {/* Main heading */}
        <h1 className="title">
          {productChainDetails?.primaryInfo?.strainName || "-"}{" "}
          <span className="batchId">
            [{productChainDetails?.primaryInfo?.coaId || "-"}]
          </span>
        </h1>
      </div>

      {/* {productChainDetails?.growerNote ? (
        <p
          className="description scroller"
          dangerouslySetInnerHTML={{
            __html: productChainDetails?.growerNote.replace(/\n/g, "<br />"),
          }}
        />
      ) : (
        "-"
      )} */}
    </div>
  );
};

export default ProductInfo;
